import { enabledPageGuard } from '@/lib/migration';
import { permissaoGuard } from '@/lib/permissions';
import { createFileRoute } from '@tanstack/react-router';
import TreinamentosPageComponent from './-component';

export const Route = createFileRoute('/__authenticated/suporte/treinamentos/')({
  beforeLoad: async () => {
    await enabledPageGuard('treinamentos', {
      redirectToOldSitePage: 'suporte/treinamentos',
    });

    await permissaoGuard('Treinamentos');
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <TreinamentosPageComponent />;
}
